var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_content"},[_c('p',{staticClass:"site"},[_c('img',{staticClass:"gonganImg",attrs:{"src":"https://attached-file.oss-cn-shanghai.aliyuncs.com/websiteImg/images/gongan.png","alt":""}}),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v(" 鲁ICP备2021024026号-1 ")])])])
}]

export { render, staticRenderFns }